import React, { useEffect, useState } from "react";
import Tengah from "./TengahDasarSubComponents/Tengah";
import Dasar from "./TengahDasarSubComponents/Dasar";
import { useDispatch, useSelector } from "react-redux";
import TengahVersiWap from "./TengahDasarSubComponents/TengahVersiWap";
import DasarVersiWap from './TengahDasarSubComponents/DasarVersiWap'
import VersiWAP from "../../MobileDesign/FourDMo/Versi_WAPP_mo/Versi_WAP_mo";
import { set4dGameSubtype, setCommonConfig } from "../../../../redux/actions";
import MarketClose from "../MarketClose.js";
import ZeroBalancePopup from "../ZeroBalancePopup";
import GameClosedPopup from "../GameClosedPopup";
import { makeAjax, respStatus, showMessage, url } from "../../../../helpers/global_helper.js";


const TengahDasar = () => {
  const dispatch = useDispatch();
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const subGameOnOffStatus = useSelector((state) => state.CommonConfig.subGameOnOffStatus);
  const marketCloseStatus = useSelector((state) => state.CommonConfig.marketCloseStatus);

  const app_type = useSelector(state => state.CommonConfig.app_type);
  const device = useSelector(state => state.CommonConfig.device_type);
  const marketStatus = useSelector((state) => state.CommonConfig.discount);
  const user_balance = useSelector(state => state.UserBalance.user_balance);
  const [subgame8, setSubgame8] = useState();
  const [subgame9, setSubgame9] = useState();
  const [activeTab, setActiveTab] = useState(1);
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    dispatch(set4dGameSubtype({ key: "game_sub_type", value: tabIndex == "1" ? "TENGAH" : "DASAR" }));
    dispatch(setCommonConfig({ key: 'gameType', value: tabIndex == "1" ? "tengahtepi" : "dasar" }))
  };
  useEffect(() => {
    dispatch(set4dGameSubtype({ key: "game_sub_type", value: "TENGAH" }));
  }, [])

  useEffect(() => {
    const reqData = { gameId };

    makeAjax(url.TOGEL_API.getSubGameStatus, reqData, url.TOGEL_MS_EXT)
      .then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          showMessage(response);
          return;
        }
        let resp = response.data;
        const subgame8 = resp.find(sub => sub.subgame_id == 8);
        const subgame9 = resp.find(sub => sub.subgame_id == 9);
        if (subgame8.status === 0) {
          handleTabClick(2);
        } else if (subgame9.status === 0) {
          handleTabClick(1);
        }
        setSubgame8(subgame8.status);
        setSubgame9(subgame9.status);
      });
  }, [activeTab])

  return (
    <>
      <div className="main_page tengah_dasar">

        <div className="main_nav-tabwrapper">
          {(subgame8 === 0 || subgame9 === 0) ? '' :
            <div
              className={`main_tab ${activeTab === 1 ? "active" : ""}`}
              onClick={() => handleTabClick(1)}
            >
              Tengah / Tepi
            </div>
          }
          {(subgame8 === 0 || subgame9 == 0) ? '' :
            <div
              className={`main_tab ${activeTab === 2 ? "active" : ""}`}
              onClick={() => handleTabClick(2)}
            >
              Dasar
            </div>
          }
        </div>


        <div className="maintabcontent-wrapper">
          {activeTab === 1 && (
            (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> :
              <div>
                {app_type === 'wap' ? (
                  <TengahVersiWap />
                ) : (
                  <Tengah />
                )}
              </div>
            )
          )}
          {activeTab === 2 && (
            (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> :
              <div>
                {app_type === 'wap' ? (
                  <DasarVersiWap />
                ) : (
                  <Dasar />
                )}
              </div>
            )
          )}
        </div>


      </div>
    </>
  );
};

export default TengahDasar;
